import * as React from 'react';
export const useSelectedOption = params => {
  const {
    value,
    groups
  } = params;
  const selectedOption = React.useMemo(() => {
    if (!value) {
      return null;
    }
    let option = null;
    groups.some(group => {
      option = group.options.find(option => option.value === value) || null;
      return !!option;
    });
    return option;
  }, [value, groups]);
  return selectedOption;
};